module.exports = __webpack_public_path__ + "img/logo.eff6f704.png";